module.exports = __webpack_public_path__ + "static/media/partitura-adult.4a94c546.png";